import React, { Component } from 'react';
import classnames from 'classnames';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Function} onPageChange
 * @prop {Number} totalCount
 * @prop {Number} currentPage
 * @prop {Number} pageSize
 * @prop {String} className
 *
 * @augments {Component<Props>}
 */

// @ts-ignore
const DOTS = '...';

export default class Pagination extends Component {

	range (start, end) {
		const length = end - start + 1;

		return Array.from({ length }, (_, idx) => idx + start);
	}

	getPaginationRange (
		totalCount,
		pageSize,
		currentPage,
		siblingCount = 1,
	) {
		const totalPageCount = Math.ceil(totalCount / pageSize);

		const totalPageNumbers = siblingCount + 5;

		if (totalPageNumbers >= totalPageCount) {
			return this.range(1, totalPageCount);
		}

		const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
		const rightSiblingIndex = Math.min(
			currentPage + siblingCount,
			totalPageCount
		);

		const shouldShowLeftDots = leftSiblingIndex > 2;
		const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;

		const firstPageIndex = 1;
		const lastPageIndex = totalPageCount;

		if (!shouldShowLeftDots && shouldShowRightDots) {
			const leftItemCount = 3 + 2 * siblingCount;
			const leftRange = this.range(1, leftItemCount);

			return [...leftRange, DOTS, totalPageCount];
		}

		if (shouldShowLeftDots && !shouldShowRightDots) {
			const rightItemCount = 3 + 2 * siblingCount;
			const rightRange = this.range(totalPageCount - rightItemCount + 1, totalPageCount);
			return [firstPageIndex, DOTS, ...rightRange];
		}

		if (shouldShowLeftDots && shouldShowRightDots) {
			const middleRange = this.range(leftSiblingIndex, rightSiblingIndex);
			return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
		}
	}

	getLastPage () {
		const { currentPage, totalCount, pageSize } = this.props;
		const paginationRange = this.getPaginationRange(
			totalCount,
			pageSize,
			currentPage,
		);

		return paginationRange[paginationRange.length - 1];
	}

	handleOnNext = () => {
		const { onPageChange, currentPage } = this.props;
		if (currentPage === this.getLastPage()) return;
		onPageChange(currentPage + 1);
	};

	handleOnPrevious = () => {
		const { onPageChange, currentPage } = this.props;
		if (currentPage === 1) return;
		onPageChange(currentPage - 1);
	};

	render () {
		const { onPageChange, currentPage, className, totalCount, pageSize } = this.props;
		const paginationRange = this.getPaginationRange(
			totalCount,
			pageSize,
			currentPage,
		);

		if (currentPage === 0 || paginationRange.length < 2) {
			return null;
		}

		return (
			<ul
				className={classnames('pagination-container', { [className]: className })}
			>
				<li
					className={classnames('pagination-item', {
						disabled: currentPage === 1,
					})}
					onClick={this.handleOnPrevious}
				>
					<div className='arrow left' />
				</li>
				{paginationRange.map((pageNumber) => {
					if (pageNumber === DOTS) {
						return <li className='pagination-item dots'>&#8230;</li>;
					}

					return (
						<li
							key={pageNumber.toString()}
							className={classnames('pagination-item', {
								selected: pageNumber === currentPage,
							})}
							onClick={() => onPageChange(pageNumber)}
						>
							{pageNumber}
						</li>
					);
				})}
				<li
					className={classnames('pagination-item', {
						disabled: currentPage === this.getLastPage(),
					})}
					onClick={this.handleOnNext}
				>
					<div className='arrow right' />
				</li>
			</ul>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/molecules/Pagination/Pagination.js